// import React from "react";

// const brands = [
//   { name: "Audi", image: "https://saitrupticabs.com/gallery-images/12.png" },
//   { name: "BMW", image: "/images/brands/bmw.png" },
//   { name: "Mercedes Benz", image: "/images/brands/mercedes-benz.png" },
//   { name: "Tesla Motors", image: "/images/brands/tesla-motors.png" },
//   { name: "Volkswagen", image: "/images/brands/volkswagen.png" },
// ];

// const BrandSection = () => {
//   return (
//     <section className="brand-section pt_120 pb_120">
//       <div className="container">
//         {/* Section title */}
//         <div className="section-title-box d-flex justify-content-between align-items-center">
//           <div className="section-title">
//             <span className="sub-title">Sai Trupti Cabs</span>
//             <h2 className="title">Explore Top Destination places with Sai Trupti Cabs</h2>
//           </div>
         
//         </div>

//         {/* Brand list */}
//         <div className="brand-outer-box">
//           {brands.map((brand, index) => (
//             <div
//               key={index}
//               className={`single-brand-item animate__backInUp animate__animated`}
//             >
//               <div className="brand-image">
//                 <img src={brand.image} alt={brand.name} />
//               </div>
//               <div className="brand-title">
//                 <h6>
//                   <a className="car-name" href="#">{brand.name}</a>
//                 </h6>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BrandSection;


import React from "react";

const destinations = [
  {
    name: "Pune to Satara",
    image: "/images/gallery-images/12.png",
  },
  {
    name: "Pune to Alibag",
    image: "/images/gallery-images/Alibag.jpg",
  },
  {
    name: "Pune to Bhimashankar",
    image: "/images/gallery-images/Bhima-Shankar.png",
  },
  {
    name: "Pune to Goa",
    image: "/images/gallery-images/Goa.png",
  },
  // {
  //   name: "Pune to Ganpatipule",
  //   image: "/images/gallery-images/Ganpatipule.jpg",
  // },
  // {
  //   name: "Pune to Kokan",
  //   image: "/images/gallery-images/kokan.png",
  // },
];

const BrandSection = () => {
  return (
    <section className="brand-section pt_120 pb_120">
      <div className="container">
        {/* Section title */}
        <div className="section-title-box text-center">
          <span className="sub-title">SAI TRUPTI CABS</span>
          <h2 className="title">
            Explore Top Destination Places With Sai Trupti Cabs
          </h2>
        </div>

        {/* Destination cards */}
        <div className="destination-grid">
          {destinations.map((dest, index) => (
            <div key={index} className="destination-card">
              <div className="destination-img-box">
                <img
                  src={dest.image}
                  alt={dest.name}
                  className="destination-img"
                />
              </div>
              <div className="destination-footer">
                <button className="destination-btn">{dest.name}</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
